export const ChanceColorBand = {
  Low: 'low',
  Mid: 'mid',
  High: 'high',
} as const;
export type ChanceColorBand = (typeof ChanceColorBand)[keyof typeof ChanceColorBand];

/** Ticket thresholds: 0–33 red, 34–67 yellow, 68–100 green (TBC). */
export const CHANCE_COLOR_LOW_MAX = 33;
export const CHANCE_COLOR_MID_MAX = 67;

export function clampChancePct(oddsPct: number | undefined): number {
  if (oddsPct == null || !Number.isFinite(oddsPct)) {
    return 0;
  }
  return Math.min(100, Math.max(0, Math.round(oddsPct)));
}

export function getChanceColorBand(chancePct: number): ChanceColorBand {
  if (chancePct <= CHANCE_COLOR_LOW_MAX) {
    return ChanceColorBand.Low;
  }
  if (chancePct <= CHANCE_COLOR_MID_MAX) {
    return ChanceColorBand.Mid;
  }
  return ChanceColorBand.High;
}
